import { ActionBar } from '../components/action-bar/models/action-bar.interfaces';

export interface ContentExpander {
  actionBar: ActionBar;
  counts: ContentExpanderCount;
  collapse: ContentExpanderCollapse;
}

export interface ContentExpanderCount {
  default: number;
  increment: number;
  total: number;
}

export interface ContentExpanderCollapse {
  block: boolean;
  full: boolean;
}

export interface ContentExpanderController {
  balance: number;
  count: number;
  expand: boolean;
}
